const SET_SESSION = "session/SET_SESSION";
const CLEAR_SESSION = "session/CLEAR_SESSION";

export const setSession = (payload) => ({ type: SET_SESSION, payload });
export const clearSession = () => ({ type: CLEAR_SESSION });

const initialState = {
  sessionToken: localStorage.getItem("sessionToken") || null,
  sessionId: localStorage.getItem("sessionId") || null,
  userId: localStorage.getItem("userId") || null,
  identityToken: null,
  userName: localStorage.getItem("userName") || null,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION: {
      const { sessionToken, sessionId, userId, identityToken, userName } = action.payload || {};

      if (sessionToken != null) localStorage.setItem("sessionToken", String(sessionToken));
      if (sessionId != null) localStorage.setItem("sessionId", String(sessionId));
      if (userId != null) localStorage.setItem("userId", String(userId));
      if (userName != null) localStorage.setItem("userName", String(userName));

      return {
        ...state,
        sessionToken: sessionToken ?? state.sessionToken,
        sessionId: sessionId ?? state.sessionId,
        userId: userId ?? state.userId,
        identityToken: identityToken ?? state.identityToken,
        userName: userName ?? state.userName,
      };
    }

    case CLEAR_SESSION: {
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("sessionId");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      return { ...initialState, sessionToken: null, sessionId: null, userId: null, identityToken: null, userName: null };
    }

    default:
      return state;
  }
};

export default sessionReducer;
export const selectSessionId = (state) => state.session.sessionId;
export const selectSessionToken = (state) => state.session.sessionToken;
export const selectUserId = (state) => state.session.userId;
export const selectIdentityToken = (state) => state.session.identityToken;
export const selectUserName = (state) => state.session.userName;